import { handleActions } from 'redux-actions';

const defaultState = {
  categoryMap: new Map(),
  sourceMap: new Map(),
  batchMap: new Map(),
  modelMap: new Map(),
  modelSnMap: new Map(),

  source: { available: [], input: [] },
  category: { available: [], input: [] },
  camera: { available: [], input: [] },
  cameraID: { input: [] },
  batch: { available: [], input: [] },
  imageSN: { input: [] },
  infrared: { input: 'ignore' },
  imageSize: {
    mode: 'disabled',
    width: { min: 0, max: 1440 },
    height: { min: 0, max: 1440 }
  },
  imageTime: {},
  evaluatedImageFilter: false,

  models: { available: [], input: [] }
};

const updateInputFieldHandlerConstructor = fieldName => (state, { payload: input }) => ({
  ...state,
  [fieldName]: { ...state[fieldName], input }
});

const handleUpdateImageSize = (state, { payload }) => ({
  ...state,
  imageSize: payload
});
const handleUpdateEvaluatedImageFilter = (state, { payload: isActive }) => ({
  ...state,
  evaluatedImageFilter: isActive
});

const handleUpdateModels = (state, { payload: { models } }) => {
  const availableModels = models.map(({ model_name: name }) => name);
  const modelMap = models.reduce(
    (acc, { model_name: name, sn }) => acc.set(name, sn),
    new Map()
  );
  const modelSnMap = models.reduce(
    (acc, { model_name: name, sn }) => acc.set(sn, name),
    new Map()
  );

  return ({
    ...state,
    modelMap,
    modelSnMap,
    models: { ...state.models, available: availableModels }
  });
};

const handleDisableImageSizeSearch = state => ({
  ...state,
  imageSize: {
    mode: 'disabled',
    width: { min: 0, max: 1440 },
    height: { min: 0, max: 1440 }
  }
});

const handleStartAppComplete = (state, {
  payload: {
    SearchParameter: {
      sources,
      categories,
      // cameras,
      batches
    }
  }
}) => {
  const validCategories = categories
    .filter(({ categories: c }) => Array.isArray(c) && c.length > 0);
  const availableCategories = validCategories.map(({ name }) => name);
  const categoryMap = validCategories.reduce(
    (acc, { categories: c, name }) => acc.set(name, c),
    new Map()
  );

  const availableSources = sources.map(({ name }) => name);
  const sourceMap = sources.reduce(
    (acc, { name, sn }) => acc.set(name, sn),
    new Map(),
  );

  const availableBatches = batches.map(({ name }) => name);
  const batchMap = batches.reduce(
    (acc, { name, sn }) => acc.set(name, sn),
    new Map()
  );

  return ({
    ...state,
    categoryMap,
    sourceMap,
    batchMap,
    source: { ...state.source, available: availableSources },
    category: { ...state.category, available: availableCategories },
    // camera: { ...state.camera, available: cameras },
    batch: { ...state.batch, available: availableBatches }
  });
};

export default handleActions({
  UPDATE_SOURCE_INPUT: updateInputFieldHandlerConstructor('source'),
  UPDATE_CATEGORY_INPUT: updateInputFieldHandlerConstructor('category'),
  UPDATE_CAMERA_INPUT: updateInputFieldHandlerConstructor('camera'),
  UPDATE_CAMERA_ID_INPUT: updateInputFieldHandlerConstructor('cameraID'),
  UPDATE_BATCH_INPUT: updateInputFieldHandlerConstructor('batch'),
  UPDATE_IMAGE_SN_INPUT: updateInputFieldHandlerConstructor('imageSN'),
  UPDATE_MODEL_INPUT: updateInputFieldHandlerConstructor('models'),
  UPDATE_IMAGE_SIZE: handleUpdateImageSize,
  UPDATE_EVALUATED_IMAGE_FILTER: handleUpdateEvaluatedImageFilter,
  UPDATE_MODELS: handleUpdateModels,
  DISABLE_IMAGE_SIZE_SEARCH: handleDisableImageSizeSearch,
  START_APP_COMPLETE: handleStartAppComplete
}, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/SearchParameter.Reducer.js